import React, { useState } from 'react';
import { Button, Dropdown, Menu } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import Papa from 'papaparse';
import './ExportButton.css';

const ExportButton = ({ api, contextHolder, data, transformData, filename = 'export.csv' }) => {
  const handleDownloadCSV = () => {
    try {
      if (!data || data.length === 0) {
        api.warning({
          message: "No hay registros para descargar.",
          className: 'notification-top-center',
          key: 'export-button'
        });
        return;
      }
      const processedData = transformData ? transformData(data) : data;
      const csv = Papa.unparse(processedData);
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      
      let notificationShown = false;
      
      const showSuccessNotification = () => {
        if (!notificationShown) {
          api.success({ 
            message: "Archivo CSV descargado con éxito.", 
            className: 'notification-top-center',
            key: 'export-button-success'
          });
          notificationShown = true;
          window.removeEventListener('focus', showSuccessNotification);
          clearTimeout(fallbackTimer);
        }
      };
      
      // Fallback para usuarios con descarga automática
      const fallbackTimer = setTimeout(showSuccessNotification, 800);
      
      // Para usuarios que ven el modal de Windows
      window.addEventListener('focus', showSuccessNotification);
      
      link.click();
      
      // Limpieza de recursos
      setTimeout(() => {
        URL.revokeObjectURL(link.href);
      }, 100);
      
    } catch (error) {
      api.error({ 
        message: "Error al descargar el CSV.", 
        key: 'export-button-error'
      });
      console.error("Error generando CSV:", error);
    }
  };

  return (
    <>
      {contextHolder}
      <Button
        type="primary"
        icon={<DownloadOutlined />}
        onClick={handleDownloadCSV}
        className="export-button"
      >
        Descargar CSV
      </Button>
    </>
  );
};

export default ExportButton;

/* import React from 'react';
import { Button, Dropdown, Menu } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import Papa from 'papaparse';
import * as XLSX from 'xlsx';
import './ExportButton.css';

const ExportButton = ({ data, transformData, filename = 'export' }) => {
  const processedData = transformData ? transformData(data) : data;

  const handleDownloadCSV = () => {
    try {
      const csv = Papa.unparse(processedData);
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });

      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `${filename}.csv`;
      link.click();
    } catch (error) {
      console.error("Error generando CSV:", error);
    }
  };

  const handleDownloadXLSX = () => {
    try {
      const worksheet = XLSX.utils.json_to_sheet(processedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Datos');

      XLSX.writeFile(workbook, `${filename}.xlsx`);
    } catch (error) {
      console.error("Error generando Excel:", error);
    }
  };

  const menu = (
    <Menu>
      <Menu.Item key="csv" onClick={handleDownloadCSV}>Descargar CSV</Menu.Item>
      <Menu.Item key="xlsx" onClick={handleDownloadXLSX}>Descargar Excel</Menu.Item>
    </Menu>
  );

  return (
    <Dropdown overlay={menu} trigger={['click']}>
      <Button
        type="primary"
        icon={<DownloadOutlined />}
        shape="circle"
        className="export-button"
      />
    </Dropdown>
  );
};

export default ExportButton; */
